'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _DateTimeHelper = require('./DateTimeHelper');

var _DateTimeHelper2 = _interopRequireDefault(_DateTimeHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var utilsModule = _angular2.default.module('utils', []).service('dateTimeHelper', _DateTimeHelper2.default);

exports.default = utilsModule;


// WEBPACK FOOTER //
// ./client/app/common/utils/utils.js